import { render, staticRenderFns } from "./pdfUpLoad.vue?vue&type=template&id=520b996e&scoped=true&"
import script from "./pdfUpLoad.vue?vue&type=script&lang=js&"
export * from "./pdfUpLoad.vue?vue&type=script&lang=js&"
import style0 from "./pdfUpLoad.vue?vue&type=style&index=0&id=520b996e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520b996e",
  null
  
)

export default component.exports